export const createMistake = (mistake) => {
  let token = "Bearer " + localStorage.getItem("jwt")
  return fetch("/api/v1/mistakes/create", {
    method: "POST",
    headers: {
      "Authorization": token,
      "Content-Type": "application/json",
      'Accept': 'application/json'
    },
    body: JSON.stringify(mistake)
  })
  .then(res => res.json())
}

